<template>
  <div class="area-select">
    <div class="area-tabs">
      <p @click="changeArea(0)">{{ province.name }}</p>
      <p v-show="active !== 0" @click="changeArea(1)">{{ city.name }}</p>
      <p v-show="active === 2" @click="changeArea(2)">{{ country.name }}</p>
    </div>
    <!-- <van-icon name="close" size="25px" @click="cancel" class="closeBtn"/> -->
    <div class="area-list">
      <van-cell class="area-cell" v-show="active === 0"
        v-for="item in provinceList" :title="item.name" :key="item.code"
        @click="provinceClick(item.code, item.name)"/>
      <van-cell class="area-cell" v-show="active === 1"
        v-for="item in cityList" :title="item.name" :key="item.code"
        @click="cityClick(item.code, item.name)"/>
      <van-cell class="area-cell" v-show="active === 2 && columns === 3"
        v-for="item in countryList" :title="item.name" :key="item.code"
        @click="countryClick(item.code, item.name)"/>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { Cell, Icon } from 'vant';
export default {
  name: 'AreaSelect',
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon
  },
  props: {
    columns: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      active: 0,
      province: {
        name: '请选择',
        code: ''
      },
      city: {
        name: '请选择',
        code: ''
      },
      country: {
        name: '请选择',
        code: ''
      },
      provinceList: [],
      cityList: [],
      countryList: [],
      selectValue: []
    };
  },
  created() {
    this.getAreaList('0', 1);
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    changeArea(type) {
      this.active = type;
      if (type === 0) {
        this.city.name = '请选择';
        this.country.name = '请选择';
      }
      if (type === 1) {
        this.country.name = '请选择';
      }
    },
    countryClick(code, name) {
      this.country.name = name;
      this.country.code = code;
      if (this.columns === 3) {
        this.$emit('confirm', [this.province, this.city, this.country]);
      }
    },
    provinceClick(code, name) {
      this.province.name = name;
      this.province.code = code;
      this.active = 1;
      this.getAreaList(code, 2);
    },
    cityClick(code, name) {
      this.city.name = name;
      this.city.code = code;
      if (this.columns === 2) {
        this.$emit('confirm', [this.province, this.city]);
      }
      if (this.columns === 3) {
        this.active = 2;
        this.getAreaList(code, 3);
      }
    },
    getAreaList(code, level) {
      api.post({
        url: '/csps-api/base/getProvince',
        data: {
          code
        }
      }).then(res => {
        if (level === 1) {
          this.provinceList = res.data.result;
        } else if (level === 2) {
          this.cityList = res.data.result;
        } else {
          this.countryList = res.data.result;
        }
      }).catch(error => {
        console.log(error);
      });
    }
  }
};
</script>

<style scoped>
.area-select{
  position: relative;
  width: 100%;
  height: 100%;
}
.area-tabs{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.area-tabs>p{
  padding: 10px;
}
.closeBtn{
  position: absolute;
  right: 10px;
  top: 5px;
}
.area-list{
  height: 85%;
  transform: translateY(40px);
  overflow: auto;
}
.area-cell{
  padding-left: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>